export const OrderPreferenceEnum = {
  wareHouseKitchenIfAvailable: 1,
  wareHouseKitchen: 2,
  vendorOnly: 3,
};

export const OrderPreferenceIdEnum = {
  1: 'Warehouse/Kitchen if Available',
  2: 'Warehouse/Kitchen',
  3: 'Distributor Direct',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/OrderPreferenceEnum.js